'use client';

import Image from 'next/image';
import { BsCalendar2EventFill } from 'react-icons/bs';
import Button from '@src/components/atoms/button';

// Assets
const DummyBanner =
  'https://images.unsplash.com/photo-1541872703-74c5e44368f9?q=80&w=1612&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

const LIST_ARTICLE = [
  {
    id: 1,
    title:
      'Tren Beli Rumah Ukuran Kecil untuk Gen Z & Milenial: Pilihan Cerdas di Era Modern',
    date: 'Rabu, 10 Juni 2026',
    image: DummyBanner,
  },
  {
    id: 2,
    title:
      'Tren Beli Rumah Ukuran Kecil untuk Gen Z & Milenial: Pilihan Cerdas di Era Modern',
    date: 'Rabu, 10 Juni 2026',
    image: DummyBanner,
  },
  {
    id: 3,
    title:
      'Tren Beli Rumah Ukuran Kecil untuk Gen Z & Milenial: Pilihan Cerdas di Era Modern',
    date: 'Rabu, 10 Juni 2026',
    image: DummyBanner,
  },
];
const Subscription = () => {
  return (
    <div
      className="py-[24px] px-[48px] bg-[#F4F2EB] flex items-center justify-between 
     dd2-2xl:p-6
     dd2-xl:block"
    >
      <div className="dd2-xl:mb-6">
        <h3
          className="text-[21px] font-satoshi-bold text-[#252526] mb-1 
        dd2-lg:text-center"
        >
          Dapatkan Insight & Update Terbaru seputar properti.
        </h3>
        <p
          className="text-[14px] font-inter text-[#686A68] 
        dd2-lg:text-center"
        >
          Berlangganan newsletter kami untuk mendapatkan artikel terbaru, tips
          ekslusif, dan update properti langsung ke email Anda.
        </p>
      </div>

      <div>
        <div
          className="flex items-center gap-2 
        dd2-lg:block"
        >
          <input
            placeholder="Masukkan alamat email Anda"
            className="h-[32px] text-[14px] font-satoshi rounded-[2px] px-[12px] border border-solid border-[#DEDFDE] placeholder:text-[14px] placeholder:font-satoshi placeholder:text-[#686A68]
              dd2-lg:w-full dd2-lg:mb-2"
          />
          <Button
            className="h-[32px] !px-[12px] !py-0 
            dd2-lg:w-full"
          >
            Berlangganan
          </Button>
        </div>
        <p className="text-[11px] font-inter text-[#686A68] mt-2">
          Kami menghargai privasi Anda. Anda dapat berhenti berlangganan kapan
          saja.
        </p>
      </div>
    </div>
  );
};

export default Subscription;
